import React from "react";
import TrafficSourceForm from "./layouts/TrafficSourceForm";
import TagTypeTable from "./layouts/TrafficSourceTable";
import { useFormAndTableSwitch } from "../../hooks/formAndTableSwitch.logic";
import Button from "@material-ui/core/Button";
import AddBoxIcon from "@material-ui/icons/AddBox";
const TrafficSource = () => {
  const { currentPage, openAddForm, openEditForm, openTable } =
    useFormAndTableSwitch();

  return (
    <div>
      {currentPage.page === "form" && (
        <TrafficSourceForm
          trafficSourceId={
            currentPage.pageData.id ? currentPage.pageData.id : ""
          }
          openTable={openTable}
        />
      )}
      {currentPage.page === "table" && (
        <div
          className="flow-content"
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "20px"
          }}
        >
          <Button
            onClick={openAddForm}
            variant="contained"
            size="medium"
            color="primary"
            startIcon={<AddBoxIcon />}
          >
            Add New Traffic Source
          </Button>
          <TagTypeTable openEditForm={openEditForm} />
        </div>
      )}
    </div>
  );
};

export default TrafficSource;
